import './index.less';
import PCShare from './pc';
import H5Share from './h5';
import WXShare from './wx';
const defaultConfig = {
  title: '',
  content: '',
  img: 'https://img.alicdn.com/tfs/TB1PLcHxborBKNjSZFjXXc_SpXa-350-350.jpg',
  targetUrl: '',
};
class ShareInstance {
  constructor(config) {
    const _config = {
      ...defaultConfig,
      ...config,
    };
    this.shareConfig = _config;
  }
  createPC() {
    return new PCShare(this.shareConfig);
  }
  async createH5() {
    const instance = new H5Share(this.shareConfig);
    await instance.setupView();
    return instance;
  }
  async wxShare() {
    new WXShare(this.shareConfig);
  }
}

export default class Share {
  /**
   * 创建分享实例
   * @param {object} config 分享配置
   * @returns {ShareInstance} 分享实例
   */
  static create(config = {}) {
    return new ShareInstance(config);
  }
  static toBrowser(message = '请使用浏览器打开页面~', canClose = true) {
    const mask = $(`<div class="share-bar-wrapper share-bar-bottom">
    <div class="share-bar-bottom-mask show share-bar-other-mask">
    <div class="top-arrow"></div>
    <p class="top-info">${message}</p>
    </div>
    </div>`);
    mask.on('click', function() {
      if (canClose) {
        $(this).remove();
      }
    });
    $('body').append(mask);
  }
}



// WEBPACK FOOTER //
// ./src/components/share/index.js